export const LINKS = {
  instagram: "https://instagram.com/tigertrailride",
  tigerlink: "https://lsu.campuslabs.com/engage/organization/tigertrailride",
  email: "hello@tigertrailride.org",
  // Placeholder external Executive Board application form — replace with the real Google Form / TigerLink URL.
  execBoardForm: "https://lsu.campuslabs.com/engage/organization/tigertrailride",
};

export const CATEGORIES = ["All", "Soul", "Service", "Professional", "Community"];
